var WATCHER_INTERVAL_DURATION = 100;
var removeWatcher = {};
function watchForElementRemoval(data) {
    // Watch for element removal => used for Single Page Application client side route change
    if (removeWatcher[data.id]) {
        clearInterval(removeWatcher[data.id]);
        delete removeWatcher[data.id];
    }
    removeWatcher[data.id] = setInterval(function () {
        if (!document.getElementById(data.targetId)) {
            // Element is removed => destroy
            window.conversionalLauncher.destroy();
            clearInterval(removeWatcher[data.id]);
        }
    }, WATCHER_INTERVAL_DURATION);
}
export function addIframeToDOM(data) {
    var iframe = window.document.createElement('iframe');
    iframe.id = data.id;
    iframe.src = data.src;
    iframe.title = data.title;
    if (data.className)
        iframe.className = data.className;
    if (data.style)
        iframe.setAttribute('style', data.style);
    if (data.onload)
        iframe.onload = data.onload;
    var target = window.document.body;
    if (data.targetId) {
        var targetElement = document.getElementById(data.targetId);
        if (targetElement) {
            // watchForElementRemoval(data)
            if (targetElement.getAttribute('data-conversional-initialized')) {
                console.error('CONVERSIONAL | Prevent double initialization', data.targetId);
                return iframe;
            }
            targetElement.setAttribute('data-conversional-initialized', '1');
            // pushInlineWidgetId(data.targetId)
        }
        target = targetElement || window.document.body;
    }
    target.prepend(iframe);
    return iframe;
}
